import get from 'lodash/get';
import omit from 'lodash/omit';
import { decodeObject } from 'utils/encoding/encoding';

export const EmbeddedRepository = {
  isEnabled() {
    return window.xprops !== undefined;
  },

  getProps() {
    if (!window.xprops) {
      return {};
    }
    return decodeObject(omit(window.xprops, 'uid'));
  },

  getProp(prop, defaultValue) {
    return get(this.getProps(), prop, defaultValue);
  },
};
